import { useEffect, useRef } from 'react';
import * as THREE from "three";

export default function VideoPlane({ position, scale, rotation }) {
  const videoRef = useRef(document.createElement('video'));
  const textureRef = useRef();

  useEffect(() => {
    const video = videoRef.current;
    video.src = './preview.mp4';
    video.crossOrigin = 'anonymous';
    video.loop = true;
    video.muted = true;
    
    video.addEventListener('canplaythrough', () => {
      video.play().catch(error => console.error('Video play error:', error));
      const texture = new THREE.VideoTexture(video);
      textureRef.current = texture;
    });

    return () => video.removeEventListener('canplaythrough', () => {});
  }, []);

  return (
    <>
      <mesh position={position} scale={scale} rotation={rotation}>
        <planeGeometry args={[4, 2.25]} />
        {textureRef.current && (
          <meshStandardMaterial 
            map={textureRef.current} 
            toneMapped={false} 
          />
        )}
      </mesh>
      {/* Simulating TV light using point light */}
      <pointLight 
        position={[-.032, 1.5, 0.88]} 
        intensity={.65} 
        color={0xffffff} 
        distance={.65} 
      />
    </>
  );
}